const actions = {
  listarFuncionarios: async (
    context,
    { page, perPage, vendorId, costCenterId, gheId, search }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get("fun/listar", {
      params: {
        page,
        perPage,
        vendorId,
        costCenterId,
        gheId,
        search,
      },
    });
    return response;
  },

  atualizarBiometriaFuncionarios: async (context) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`auth/users/refresh-biometry`);

    return response;
  },

  desligarFuncionario: async (context, { id }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(`fun/${id}/excluir`);

    return response;
  },

  alterarStatusFuncionario: async (context, { id, status }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(`fun/${id}/escolher-status`, {
      status,
    });

    return response;
  },

  reativarFuncionario: async (context, { id }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(`fun/${id}/reativar-funcionario`);

    return response;
  },

  cadastrarFuncionario: async (
    context,
    {
      sap,
      name,
      email,
      vendor_id,
      cost_center_id,
      function_id,
      admission_date,
      resignation_date,
      cargo,
      vendor_shift_id,
      tnumber,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`fun/criar`, {
      sap,
      name,
      email,
      vendor_id,
      cost_center_id,
      function_id,
      admission_date,
      resignation_date,
      cargo,
      vendor_shift_id,
      tnumber,
    });

    return response;
  },

  detalharFuncionario: async (context, { id }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`fun/${id}/detalhar-funcionario`);

    return response;
  },

  editarFuncionario: async (
    context,
    {
      id,
      name,
      email,
      sap,
      cost_center_id,
      function_id,
      admission_date,
      resignation_date,
      cargo,
      vendor_shift_id,
      tnumber,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(`fun/${id}/editar`, {
      sap,
      name,
      email,
      cost_center_id,
      function_id,
      admission_date,
      resignation_date,
      cargo,
      vendor_shift_id,
      tnumber,
    });

    return response;
  },

  cadastrarPinFuncionario: async (
    context,
    { cartao_id, senha, funcionario_id }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`fun/pin/cadastrar`, {
      cartao_id,
      senha,
      funcionario_id,
    });

    return response;
  },

  excluirPinFuncionario: async (context, { id }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(`fun/pin/${id}`);

    return response;
  },

  editarPinFuncionario: async (context, { card_id, user_id, password, id }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(`fun/pin/${id}`, {
      card_id,
      user_id,
      password,
    });

    return response;
  },

  alterarPerfilFuncionario: async (context, { perfilId, id }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(`fun/${id}/alterar-perfil/${perfilId}`);

    return response;
  },

  cadastrarBiometria: async (
    context,
    {
      employeeId,
      base64Image,
      fingerPosition,
      imageWidth,
      imageHeight,
      imageResolution,
    }
  ) => {
    const api = context.rootState.autenticacao.apiBioMultpex;
    const response = await api.post(`EmployeeAuth/enroll`, {
      employeeId,
      base64Image,
      fingerPosition,
      imageWidth,
      imageHeight,
      imageResolution,
    });

    return response;
  },

  verificarBiometria: async (
    context,
    { userId, base64Image, imageWidth, imageHeight, imageResolution }
  ) => {
    const api = context.rootState.autenticacao.apiBioMultpex;
    try {
      const response = await api.post(`EmployeeAuth/Identify`, {
        userId,
        base64Image,
        imageWidth,
        imageHeight,
        imageResolution,
      });

      return response;
    } catch (error) {
      console.log(error);
    }
  },

  verificarUsuarioBiometria: async (
    context,
    { userId, base64Image, imageWidth, imageHeight, imageResolution }
  ) => {
    const api = context.rootState.autenticacao.apiBioMultpex;
    try {
      const response = await api.post(`EmployeeAuth/Identify`, {
        userId,
        base64Image,
        imageWidth,
        imageHeight,
        imageResolution,
      });

      return response;
    } catch (error) {
      console.log(error);
    }
  },

  receberDedosCadastrados: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiBioMultpex;
    const response = await api.get(`EmployeeAuth/Employee/${id}/Fingers`);

    return response;
  },
};

export const usuarioNovo = {
  namespaced: true,
  actions,
};
